import React from "react";
function Heading() {
  return (
    <h1 class="app-heading">
      <strong>HELLO! I'M THULASI!</strong>
    </h1>
  );
}
export default Heading;
